module.exports = __webpack_public_path__ + "img/left-chevron.634ee786.svg";